import * as React from 'react';

interface ILabelProps {
    text: string;
    to?: string;
}

const Input = (props: ILabelProps) => {
    const { text, to } = props;

    return (
        <label className="label" htmlFor={to}>{text}</label>
    );
};

export default Input;



// WEBPACK FOOTER //
// ./src/modules/Form/Label.tsx